import React from 'react';

function CardButton({ source, buttonName }) {
  return (
    <a href={ source } target="_blank">
      <button
        type="button"
        className="bg-lightGreen hover:bg-emerald-400 text-zinc-900 rounded-2xl h-9 lg:h-7 w-24 lg:w-24 xl:h-9 xl:w-32 md:w-36 font-semibold active:translate-y-2 transition duration-200"
      >
        { buttonName }
      </button>
    </a>
  );
}

export default CardButton;
